import React from 'react';
import Image from 'next/image';
import useMediaQuery from '@restart/hooks/useMediaQuery';
import { minBreakpoints } from '../../../utils/media-queries';

interface ImageProps {
  imageSize: { width: number; height: number };
}

const SAVE_INSTALLATION_IMAGE_HUG = '/td-home/images/landingpage/hero/hug/discount-badge.png';

export const HugDiscountBadge: React.FC<ImageProps> = ({ imageSize }) => {
  const isMdOrAbove = useMediaQuery(`(min-width: ${minBreakpoints.sm}px)`);

  const styles = isMdOrAbove
    ? {
        width: imageSize.width,
        height: imageSize.height,
        right: -60,
        top: -70,
        padding: 0,
        margin: 0
      }
    : {
        width: imageSize.width,
        height: imageSize.height,
        right: 0,
        top: -70,
        padding: 0,
        margin: 0
      };

  return (
    <Image
      style={styles}
      className="mt-3 position-absolute image-cards-badge"
      width={imageSize.width}
      height={imageSize.height}
      src={SAVE_INSTALLATION_IMAGE_HUG}
      alt={'Jetzt noch Installation sichern!'}
    />
  );
};
